import '../App.css';
import { Link } from 'react-router-dom';
import arrow_down from '../images/pics/arrow-down.png'
import { useState, useEffect } from 'react';
import { scrollToSection } from './Header';
import swingTheory from '../images/project_pics/Swing-Logo.png';
import caesar from '../images/project_pics/Caesar-Logo.png';
// import amazonworker from '../images/project_pics/AmazonWorker-Logo.png';
import goodviews from '../images/project_pics/Goodviews-Logo.png';
import globalhorizon from '../images/project_pics/globalhorizon-Logo.png';
import { useTitleCardPos } from '../TitleCards';

export default function Projects() {

    const { project, contact } = useTitleCardPos();

    const [arrowVisible, setArrowVisible] = useState(true);

    const [slideRowOne, setSlideRowOne] = useState(false);
        
    useEffect(() => {
    const onScroll = () => {
        const scroll = window.scrollY;
        const arrow = scroll < 2400 ? true : false;
        if (scroll > 1200) {
            setSlideRowOne(true);
        }

        setArrowVisible(arrow);
    }
    
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
    }, []);
    
        return(
        <div>
            <div ref={project} className='title-container'>
                <div className='title'>
                    Featured <span style={{ color: '#598fcb' }}>Projects</span>
                </div>
            </div>
            <nav>
                <div className='project-container'>
                    <div className='project-grid'>

                        <Project
                            link={"/swingtheory"}
                            img={swingTheory}
                            title={'SwingTheory'}
                            description={'UX Design | Body Tracking Software | Machine Learning'}
                            date={'July 2024 - October 2024'}
                            skills={['User Flow', 'React App', 'AI Model']}
                            slide={slideRowOne}
                        />
                        <Project
                            link={"/goodviews"}
                            img={goodviews}
                            title={'Good Views'}
                            description={'Smooth UI | Movie Recommendation | Friend Collaboration'}
                            date={'April 2026 - May 2026'}
                            skills={['UX Design', 'API Implementation', 'Database Management']}
                            slide={slideRowOne}
                        />
                        <Project
                            link={"/globalhorizon"}
                            img={globalhorizon}
                            title={'Global Horizon'}
                            description={'Global Collaboration Platform | Discovery'}
                            date={'April 2026 - May 2026'}
                            skills={['UX Design', 'Security', 'System Architecture', 'User Stories']}
                            slide={slideRowOne}
                        /> 

                        <Project
                            link={"/caesar"}
                            img={caesar}
                            title={'Caesar Cipher'}
                            description={'Encryption Software | Python'}
                            date={'January 2026'}
                            skills={['Python', 'Algorithms', 'Cryptography']}
                            slide={slideRowOne}
                        />

                        {/* <Project
                            link={"/amazonworker"}
                            img={amazonworker}
                            title={'Amazon Worker'}
                            description={'Hardware Project | Arduino | Abstract'}
                            date={'March 2025 - June 2025'}
                            skills={['Arduino', 'Hardware', 'Problem Solving']}
                            slide={slideRowOne}
                        /> */}
                    </div>
                    <div className='project-grid bottom-grid'>
                        
                    </div>
                </div>
            </nav>


            {arrowVisible ? /*Arrow conponent*/
            <span className='arrow-down'>
                <img 
                src={arrow_down} 
                alt='arrow going down'
                
                onClick={() => scrollToSection('contact', contact)}
                />
            </span> :
            <span className='arrow-down'/>
            }
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className='line'/>
            </div>
        </div>
    )
}

function Project({ link, img, title, description, date, skills, slide }) {
    /**
     * link = Link to the react route page of that project
     * img = Imported image for that project
     * description = small blurb that summarises the project
     * skills = array of important/relevant skills of that project
     */

    return (
        <Link to={link} style={{ textDecoration: 'none' }}>
            <div className={'project-card'} style={{ opacity: slide ? '1' : '0' }}>
                <img src={img} alt='Pic of my project' />
                <div className='desc-container'>
                    <div className='project-title'>{title}</div>
                    <div className='project-desc'>{description}</div>
                    <div className='project-date'>{date}</div>
                    <div className='skill-grid' style={{ marginTop: skills.length > 3 ? '0px' : '8px' }}>
                        {skills.map(skill => (
                            <div className='skill' key={skill}>{skill}</div>
                        ))}
                    </div>
                </div>
            </div>
        </Link>
    )

}